import {
  isValid,
  parseISO,
  startOfDay,
  subDays,
} from 'date-fns'

export type ContactInfoStage = 'upcoming' | 'travel-guide' | 'customer-support' | null

export function getContactInfoStage(
  rawDepartureDate: string | undefined,
  rawReturnDate: string | undefined,
  daysBeforeContactInfo: number,
  isCancelled: boolean = false,
  now: Date = new Date(),
): ContactInfoStage {
  if (isCancelled || !rawDepartureDate || !rawReturnDate) {
    return null
  }

  const departure = parseISO(rawDepartureDate)
  const returnDate = parseISO(rawReturnDate)

  if (!isValid(departure) || !isValid(returnDate)) {
    return null
  }

  const today = startOfDay(now)
  const boundaryDay = subDays(startOfDay(departure), daysBeforeContactInfo)

  if (today > startOfDay(returnDate)) {
    return 'customer-support'
  }

  if (today >= boundaryDay) {
    return 'travel-guide'
  }

  return 'upcoming'
}
